/* eslint-disable react/prop-types */
import React, { useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";
import FormularioUsuario from "./FormularioUsuario";

export default function ModalUsuario({ open, onClose, modo, usuario, onGuardar }) {
  const formRef = useRef();

  const handleGuardar = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  const handleSubmitData = async (datos) => {
    const result = await onGuardar(datos);
    return result;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{modo === "insertar" ? "Nuevo Usuario" : "Editar Usuario"}</DialogTitle>
      <DialogContent>
        <FormularioUsuario ref={formRef} modo={modo} usuario={usuario} onSubmit={handleSubmitData} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="danger">Cancelar</Button>
        <Button onClick={handleGuardar} color="success">Guardar</Button>
      </DialogActions>
    </Dialog>
  );
}
